import { Component, computed, input } from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';
import {
  AdministrativeOffer,
  AdministrativeOfferDocument,
} from '../../../../../api/interfaces';

interface Badge {
  label: string;
  classes: string;
}

const GREEN = 'bg-green-100 text-green-700';
const AMBER = 'bg-amber-100 text-amber-800';
const RED = 'bg-red-100 text-red-700';
const NEUTRAL = 'bg-slate-100 text-slate-600';

/**
 * The model's status only says whether a file was supplied. The badge also says whether
 * the applicant has something to do: fix a supplied file, or check whether an optional
 * document applies to them.
 */
export function documentBadge(doc: AdministrativeOfferDocument): Badge {
  if (doc.status === 'PRESENTE') {
    return doc.hasIssues
      ? { label: 'Da correggere', classes: AMBER }
      : { label: 'Presente', classes: GREEN };
  }
  // Older evaluations may lack the flag: treat them as mandatory, as before.
  return doc.isMandatory === false
    ? { label: 'Se applicabile', classes: NEUTRAL }
    : { label: 'Mancante', classes: RED };
}

@Component({
  selector: 'lib-result-administrative-offer-card',
  standalone: true,
  imports: [CardComponent],
  templateUrl: './administrative-offer-card.component.html',
})
export class ResultAdministrativeOfferCardComponent {
  administrativeOffer = input<AdministrativeOffer | null | undefined>();

  outcomeClasses = computed(() => {
    switch (this.administrativeOffer()?.preliminaryOutcome) {
      case 'AMMESSA':
        return GREEN;
      case 'DA INTEGRARE':
        return AMBER;
      default:
        return RED;
    }
  });

  documents = computed(() =>
    (this.administrativeOffer()?.requiredDocuments ?? []).map((doc) => ({
      doc,
      badge: documentBadge(doc),
    })),
  );
}
